/**************
 * 以下维护本模块内上下文
 * 后续如果业务进一步复杂，需考虑引入redux停止引入更多的上下文
 *************/
import React from 'react';

/* activityReceipt模块级上下文 */
export const ActivityReceiptContext = React.createContext([]);

/* activityReceit业务内页面相关上下文 - 业务相关 */
export const JoinAndManageContext = React.createContext([]);
